import './ProteinList.css'

import React from 'react'
import { Table } from 'react-bootstrap'
import { useSelector } from 'react-redux'

const ProteinList = () => {
  const crystals = useSelector(state => state.proposalInfo.data.map(d => d.crystals).flat())

  return (
    <>
      <div>
        <h2>My Proteins ({crystals.length})</h2>
      </div>
      <div className="center-div">
        {crystals
          .sort((a, b) => b.crystalId - a.crystalId)
          .map(crystal => (
            <Table border="3" className="proteinlisttable" key={crystal.crystalId}>
              <tbody border="2">
                <tr>
                  <td>Acronym : </td>
                  <td>{crystal.proteinVO.acronym}</td>
                </tr>

                <tr>
                  <td>Name : </td>
                  <td>{crystal.proteinVO.name}</td>
                </tr>
                <tr>
                  <td>a, b, c </td>
                  <td>
                    {crystal.cellA}, {crystal.cellB}, {crystal.cellC}
                  </td>
                </tr>
                <tr>
                  <td>α, β, γ</td>
                  <td>
                    {crystal.cellAlpha}, {crystal.cellBeta}, {crystal.cellGamma}
                  </td>
                </tr>
              </tbody>
            </Table>
          ))}
      </div>
    </>
  )
}

export default ProteinList
